import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ScoringLoader from 'general/js/loaders/scoring-loader';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';
import { bemClasses, LivePreMessage } from 'components/live-pre-message';
import QualLeaderboardContainer from './qual-leaderboard-container';

class QualLeaderboardLayout extends React.Component {
    componentDidMount() {
        ScoringLoader.subscribe(`summary${this.props.options.type}`);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(`summary${this.props.options.type}`);
    }

    getLocationById(id) {
        const { scoringSummary } = this.props;

        if (!scoringSummary || !Array.isArray(scoringSummary.locations)) return null;

        const location = scoringSummary.locations.find((item) =>
            item.locationId === id);

        return location || null;
    }


    render() {
        const { scoringSummary } = this.props;

        if (scoringSummary === undefined) {
            return (
                <BlockPlaceholder minHeight={300}>
                    <BlockSpinner />
                </BlockPlaceholder>
            );
        }

        const location = this.getLocationById(this.props.options.locationId);

        if (!location || !Array.isArray(location.players)) {
            return <LivePreMessage bemList={[bemClasses.DARK]} />;
        }

        return <QualLeaderboardContainer {...this.props} location={location} />;
    }
}

QualLeaderboardLayout.propTypes = {
    options: PropTypes.object
};

const mapStateToProps = (state, ownProps) => ({
    scoringSummary: state.scoring[`summary${ownProps.options.type}`]
});

const QualLeaderboardLayoutWrapper = connect(
    mapStateToProps
)(QualLeaderboardLayout);

export default QualLeaderboardLayoutWrapper;
